// src/pages/approvals/StoreRequests.js
import React from "react";
import StoreList from "../../components/StoreList";

export default function StoreRequests() {
    return (
        <div>
            <div style={{ marginBottom: 14 }}>
                <h2 style={{ margin: 0 }}>Store Requests</h2>
                <div style={{ color: "#857969", fontSize: 13, marginTop: 4 }}>
                    Approve or reject new Store registrations.
                </div>
            </div>

            <StoreList />
        </div>
    );
}
